import { c as _c } from "react/compiler-runtime";
import type { GithubRepository } from '@/types/github';
import { useQuery } from '@tanstack/react-query';
export const getRepositoryQueryKey = (owner: string, repo: string) => ['repository', owner, repo] as const;
export async function getRepositoryFn(owner: string, repo: string, signal?: AbortSignal) {
  const response = await fetch(`/inbox/api/${owner}/${repo}`, {
    credentials: 'include',
    signal
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to fetch repository');
  }
  return response.json() as Promise<GithubRepository>;
}
export function useRepository(owner, repo) {
  const $ = _c(10);
  let t0;
  if ($[0] !== owner || $[1] !== repo) {
    t0 = getRepositoryQueryKey(owner, repo);
    $[0] = owner;
    $[1] = repo;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== owner || $[4] !== repo) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return getRepositoryFn(owner, repo, signal);
    };
    $[3] = owner;
    $[4] = repo;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = Boolean(owner && repo);
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useQuery(t3);
}